// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

/*========================================================================
	
	Table of contents
	
	01. Transition CSS
	02. Font Size
	03. Social icon color
	04. Padding
	05. Margin
	06. Border

========================================================================*/

/*--------------------------
	01. Transition CSS
--------------------------*/
.transition-1s {
	transition: all 1s ease-in-out;
}
.transition-02s {
	transition: all 0.2s ease-in-out;
}
.transition-03s {
	transition: all 0.3s ease-in-out;
}
.transition-04s {
	transition: all 0.4s ease-in-out;
}
.transition-05s {
	transition: all 0.5s ease-in-out;
}
.transition-06s {
	transition: all 0.6s ease-in-out;
}
/*--------------------------
	02. Font Size
--------------------------*/
.font-size-12 {
	font-size: 12px;
}
.font-size-13 {
	font-size: 13px;
}
.font-size-14 {
	font-size: 14px;
}
.font-size-15 {
	font-size: 15px;
}
.font-size-16 {
	font-size: 16px;
}
.font-size-17 {
	font-size: 17px;
}
.font-size-18 {
	font-size: 18px;
}
.font-size-19 {
	font-size: 19px;
}
.font-size-20 {
	font-size: 20px;
}
.font-size-21 {
	font-size: 21px;
}
.font-size-22 {
	font-size: 22px;
}
.font-size-23 {
	font-size: 23px;
}
.font-size-24 {
	font-size: 24px;
}
.font-size-25 {
	font-size: 25px;
}
.font-size-26 {
	font-size: 26px;
}
.font-size-27 {
	font-size: 27px;
}
.font-size-28 {
	font-size: 28px;
}
.font-size-29 {
	font-size: 29px;
}
.font-size-30 {
	font-size: 30px;
}
.font-size-31 {
	font-size: 31px;
}
.font-size-32 {
	font-size: 32px;
}
.font-size-33 {
	font-size: 33px;
}
.font-size-34 {
	font-size: 34px;
}
.font-size-35 {
	font-size: 35px;
}
.font-size-36 {
	font-size: 36px;
}
.font-size-37 {
	font-size: 37px;
}
.font-size-38 {
	font-size: 38px;
}
.font-size-39 {
	font-size: 39px;
}
.font-size-40 {
	font-size: 40px;
}
.font-size-41 {
	font-size: 41px;
}
.font-size-42 {
	font-size: 42px;
}
.font-size-43 {
	font-size: 43px;
}
.font-size-44 {
	font-size: 44px;
}
.font-size-45 {
	font-size: 45px;
}
.font-size-46 {
	font-size: 46px;
}
.font-size-47 {
	font-size: 47px;
}
.font-size-48 {
	font-size: 48px;
}
.font-size-49 {
	font-size: 49px;
}
.font-size-50 {
	font-size: 50px;
}
.font-size-51 {
	font-size: 51px;
}
.font-size-52 {
	font-size: 52px;
}
.font-size-53 {
	font-size: 53px;
}
.font-size-54 {
	font-size: 54px;
}
.font-size-55 {
	font-size: 55px;
}
.font-size-56 {
	font-size: 56px;
}
.font-size-57 {
	font-size: 57px;
}
.font-size-58 {
	font-size: 58px;
}
.font-size-59 {
	font-size: 59px;
}
.font-size-60 {
	font-size: 60px;
}
/*--------------------------
	03. Social icon color
--------------------------*/
/* Social color */
.facebook-color {
	color: #3a559f;
}
.twitter-color {
	color: #2aaae0;
}
.linkedin-color {
	color: #007bb5;
}
.google-plus-color {
	color: #dc4335;
}
.pinterest-color {
	color: #cb2027;
}
.whatsapp-color {
	color: #0dc143;
}
.youtube-color {
	color: #e42b33;
}
.instagram-color {
	color: #c82d9e;
}
.skype-color {
	color: #31c5ed;
}
/* Social background color */
.facebook-bg-color {
	background-color: #3a559f;
}
.twitter-bg-color {
	background-color: #2aaae0;
}
.linkedin-bg-color {
	background-color: #007bb5;
}
.google-plus-bg-color {
	background-color: #dc4335;
}
.pinterest-bg-color {
	background-color: #cb2027;
}
.whatsapp-bg-color {
	background-color: #0dc143;
}
.youtube-bg-color {
	background-color: #e42b33;
}
.instagram-bg-color {
	background-color: #c82d9e;
}
.skype-bg-color {
	background-color: #31c5ed;
}
/*--------------------------
	04. padding
--------------------------*/
/* padding all */
.p-6 {
	padding: 6px;
}
.p-7 {
	padding: 7px;
}
.p-8 {
	padding: 8px;
}
.p-9 {
	padding: 9px;
}
.p-10 {
	padding: 10px;
}
.p-11 {
	padding: 11px;
}
.p-12 {
	padding: 12px;
}
.p-13 {
	padding: 13px;
}
.p-14 {
	padding: 14px;
}
.p-15 {
	padding: 15px;
}
.p-16 {
	padding: 16px;
}
.p-17 {
	padding: 17px;
}
.p-18 {
	padding: 18px;
}
.p-19 {
	padding: 19px;
}
.p-20 {
	padding: 20px;
}
.p-21 {
	padding: 21px;
}
.p-22 {
	padding: 22px;
}
.p-23 {
	padding: 23px;
}
.p-24 {
	padding: 24px;
}
.p-25 {
	padding: 25px;
}
.p-26 {
	padding: 26px;
}
.p-27 {
	padding: 27px;
}
.p-28 {
	padding: 28px;
}
.p-29 {
	padding: 29px;
}
.p-30 {
	padding: 30px;
}
.p-31 {
	padding: 31px;
}
.p-32 {
	padding: 32px;
}
.p-33 {
	padding: 33px;
}
.p-34 {
	padding: 34px;
}
.p-35 {
	padding: 35px;
}
.p-36 {
	padding: 36px;
}
.p-37 {
	padding: 37px;
}
.p-38 {
	padding: 38px;
}
.p-39 {
	padding: 39px;
}
.p-40 {
	padding: 40px;
}
.p-45 {
	padding: 45px;
}
.p-50 {
	padding: 50px;
}
.p-55 {
	padding: 55px;
}
.p-60 {
	padding: 60px;
}
.p-65 {
	padding: 65px;
}
.p-70 {
	padding: 70px;
}
.p-75 {
	padding: 75px;
}
.p-80 {
	padding: 80px;
}
.p-85 {
	padding: 85px;
}
.p-90 {
	padding: 90px;
}
.p-95 {
	padding: 95px;
}
.p-100 {
	padding: 100px;
}
.p-105 {
	padding: 105px;
}
.p-110 {
	padding: 110px;
}
.p-115 {
	padding: 115px;
}
.p-120 {
	padding: 120px;
}
.p-125 {
	padding: 125px;
}
.p-130 {
	padding: 135px;
}
.p-135 {
	padding: 135px;
}
.p-140 {
	padding: 140px;
}
.p-145 {
	padding: 145px;
}
.p-150 {
	padding: 150px;
}
/* padding top */
.pt-6 {
	padding-top: 6px;
}
.pt-7 {
	padding-top: 7px;
}
.pt-8 {
	padding-top: 8px;
}
.pt-9 {
	padding-top: 9px;
}
.pt-10 {
	padding-top: 10px;
}
.pt-11 {
	padding-top: 11px;
}
.pt-12 {
	padding-top: 12px;
}
.pt-13 {
	padding-top: 13px;
}
.pt-14 {
	padding-top: 14px;
}
.pt-15 {
	padding-top: 15px;
}
.pt-16 {
	padding-top: 16px;
}
.pt-17 {
	padding-top: 17px;
}
.pt-18 {
	padding-top: 18px;
}
.pt-19 {
	padding-top: 19px;
}
.pt-20 {
	padding-top: 20px;
}
.pt-21 {
	padding-top: 21px;
}
.pt-22 {
	padding-top: 22px;
}
.pt-23 {
	padding-top: 23px;
}
.pt-24 {
	padding-top: 24px;
}
.pt-25 {
	padding-top: 25px;
}
.pt-26 {
	padding-top: 26px;
}
.pt-27 {
	padding-top: 27px;
}
.pt-28 {
	padding-top: 28px;
}
.pt-29 {
	padding-top: 29px;
}
.pt-30 {
	padding-top: 30px;
}
.pt-31 {
	padding-top: 31px;
}
.pt-32 {
	padding-top: 32px;
}
.pt-33 {
	padding-top: 33px;
}
.pt-34 {
	padding-top: 34px;
}
.pt-35 {
	padding-top: 35px;
}
.pt-36 {
	padding-top: 36px;
}
.pt-37 {
	padding-top: 37px;
}
.pt-38 {
	padding-top: 38px;
}
.pt-39 {
	padding-top: 39px;
}
.pt-40 {
	padding-top: 40px;
}
.pt-45 {
	padding-top: 45px;
}
.pt-50 {
	padding-top: 50px;
}
.pt-55 {
	padding-top: 55px;
}
.pt-60 {
	padding-top: 60px;
}
.pt-65 {
	padding-top: 65px;
}
.pt-70 {
	padding-top: 70px;
}
.pt-75 {
	padding-top: 75px;
}
.pt-80 {
	padding-top: 80px;
}
.pt-85 {
	padding-top: 85px;
}
.pt-90 {
	padding-top: 90px;
}
.pt-95 {
	padding-top: 95px;
}
.pt-100 {
	padding-top: 100px;
}
.pt-105 {
	padding-top: 105px;
}
.pt-110 {
	padding-top: 110px;
}
.pt-115 {
	padding-top: 115px;
}
.pt-120 {
	padding-top: 120px;
}
.pt-125 {
	padding-top: 125px;
}
.pt-130 {
	padding-top: 130px;
}
.pt-135 {
	padding-top: 135px;
}
.pt-140 {
	padding-top: 140px;
}
.pt-145 {
	padding-top: 145px;
}
.pt-150 {
	padding-top: 150px;
}
/* padding bottom */
.pb-6 {
	padding-bottom: 6px;
}
.pb-7 {
	padding-bottom: 7px;
}
.pb-8 {
	padding-bottom: 8px;
}
.pb-9 {
	padding-bottom: 9px;
}
.pb-10 {
	padding-bottom: 10px;
}
.pb-11 {
	padding-bottom: 11px;
}
.pb-12 {
	padding-bottom: 12px;
}
.pb-13 {
	padding-bottom: 13px;
}
.pb-14 {
	padding-bottom: 14px;
}
.pb-15 {
	padding-bottom: 15px;
}
.pb-16 {
	padding-bottom: 16px;
}
.pb-17 {
	padding-bottom: 17px;
}
.pb-18 {
	padding-bottom: 18px;
}
.pb-19 {
	padding-bottom: 19px;
}
.pb-20 {
	padding-bottom: 20px;
}
.pb-21 {
	padding-bottom: 21px;
}
.pb-22 {
	padding-bottom: 22px;
}
.pb-23 {
	padding-bottom: 23px;
}
.pb-24 {
	padding-bottom: 24px;
}
.pb-25 {
	padding-bottom: 25px;
}
.pb-26 {
	padding-bottom: 26px;
}
.pb-27 {
	padding-bottom: 27px;
}
.pb-28 {
	padding-bottom: 28px;
}
.pb-29 {
	padding-bottom: 29px;
}
.pb-30 {
	padding-bottom: 30px;
}
.pb-31 {
	padding-bottom: 31px;
}
.pb-32 {
	padding-bottom: 32px;
}
.pb-33 {
	padding-bottom: 33px;
}
.pb-34 {
	padding-bottom: 34px;
}
.pb-35 {
	padding-bottom: 35px;
}
.pb-36 {
	padding-bottom: 36px;
}
.pb-37 {
	padding-bottom: 37px;
}
.pb-38 {
	padding-bottom: 38px;
}
.pb-39 {
	padding-bottom: 39px;
}
.pb-40 {
	padding-bottom: 40px;
}
.pb-45 {
	padding-bottom: 45px;
}
.pb-50 {
	padding-bottom: 50px;
}
.pb-55 {
	padding-bottom: 55px;
}
.pb-60 {
	padding-bottom: 60px;
}
.pb-65 {
	padding-bottom: 65px;
}
.pb-70 {
	padding-bottom: 70px;
}
.pb-75 {
	padding-bottom: 75px;
}
.pb-80 {
	padding-bottom: 80px;
}
.pb-85 {
	padding-bottom: 85px;
}
.pb-90 {
	padding-bottom: 90px;
}
.pb-95 {
	padding-bottom: 95px;
}
.pb-100 {
	padding-bottom: 100px;
}
.pb-105 {
	padding-bottom: 105px;
}
.pb-110 {
	padding-bottom: 110px;
}
.pb-115 {
	padding-bottom: 115px;
}
.pb-120 {
	padding-bottom: 120px;
}
.pb-125 {
	padding-bottom: 125px;
}
.pb-130 {
	padding-bottom: 130px;
}
.pb-135 {
	padding-bottom: 135px;
}
.pb-140 {
	padding-bottom: 140px;
}
.pb-145 {
	padding-bottom: 145px;
}
.pb-150 {
	padding-bottom: 150px;
}
/* padding left */
.pl-6 {
	padding-left: 6px;
}
.pl-7 {
	padding-left: 7px;
}
.pl-8 {
	padding-left: 8px;
}
.pl-9 {
	padding-left: 9px;
}
.pl-10 {
	padding-left: 10px;
}
.pl-11 {
	padding-left: 11px;
}
.pl-12 {
	padding-left: 12px;
}
.pl-13 {
	padding-left: 13px;
}
.pl-14 {
	padding-left: 14px;
}
.pl-15 {
	padding-left: 15px;
}
.pl-16 {
	padding-left: 16px;
}
.pl-17 {
	padding-left: 17px;
}
.pl-18 {
	padding-left: 18px;
}
.pl-19 {
	padding-left: 19px;
}
.pl-20 {
	padding-left: 20px;
}
.pl-21 {
	padding-left: 21px;
}
.pl-22 {
	padding-left: 22px;
}
.pl-23 {
	padding-left: 23px;
}
.pl-24 {
	padding-left: 24px;
}
.pl-25 {
	padding-left: 25px;
}
.pl-26 {
	padding-left: 26px;
}
.pl-27 {
	padding-left: 27px;
}
.pl-28 {
	padding-left: 28px;
}
.pl-29 {
	padding-left: 29px;
}
.pl-30 {
	padding-left: 30px;
}
.pl-31 {
	padding-left: 31px;
}
.pl-32 {
	padding-left: 32px;
}
.pl-33 {
	padding-left: 33px;
}
.pl-34 {
	padding-left: 34px;
}
.pl-35 {
	padding-left: 35px;
}
.pl-36 {
	padding-left: 36px;
}
.pl-37 {
	padding-left: 37px;
}
.pl-38 {
	padding-left: 38px;
}
.pl-39 {
	padding-left: 39px;
}
.pl-40 {
	padding-left: 40px;
}
.pl-45 {
	padding-left: 45px;
}
.pl-50 {
	padding-left: 50px;
}
.pl-55 {
	padding-left: 55px;
}
.pl-60 {
	padding-left: 60px;
}
.pl-65 {
	padding-left: 65px;
}
.pl-70 {
	padding-left: 70px;
}
.pl-75 {
	padding-left: 75px;
}
.pl-80 {
	padding-left: 80px;
}
.pl-85 {
	padding-left: 85px;
}
.pl-90 {
	padding-left: 90px;
}
.pl-95 {
	padding-left: 95px;
}
.pl-100 {
	padding-left: 100px;
}
.pl-105 {
	padding-left: 105px;
}
.pl-110 {
	padding-left: 110px;
}
.pl-115 {
	padding-left: 115px;
}
.pl-120 {
	padding-left: 120px;
}
.pl-125 {
	padding-left: 125px;
}
.pl-130 {
	padding-left: 130px;
}
.pl-135 {
	padding-left: 135px;
}
.pl-140 {
	padding-left: 140px;
}
.pl-145 {
	padding-left: 145px;
}
.pl-150 {
	padding-left: 150px;
}
/* padding right */
.pr-6 {
	padding-right: 6px;
}
.pr-7 {
	padding-right: 7px;
}
.pr-8 {
	padding-right: 8px;
}
.pr-9 {
	padding-right: 9px;
}
.pr-10 {
	padding-right: 10px;
}
.pr-11 {
	padding-right: 11px;
}
.pr-12 {
	padding-right: 12px;
}
.pr-13 {
	padding-right: 13px;
}
.pr-14 {
	padding-right: 14px;
}
.pr-15 {
	padding-right: 15px;
}
.pr-16 {
	padding-right: 16px;
}
.pr-17 {
	padding-right: 17px;
}
.pr-18 {
	padding-right: 18px;
}
.pr-19 {
	padding-right: 19px;
}
.pr-20 {
	padding-right: 20px;
}
.pr-21 {
	padding-right: 21px;
}
.pr-22 {
	padding-right: 22px;
}
.pr-23 {
	padding-right: 23px;
}
.pr-24 {
	padding-right: 24px;
}
.pr-25 {
	padding-right: 25px;
}
.pr-26 {
	padding-right: 26px;
}
.pr-27 {
	padding-right: 27px;
}
.pr-28 {
	padding-right: 28px;
}
.pr-29 {
	padding-right: 29px;
}
.pr-30 {
	padding-right: 30px;
}
.pr-31 {
	padding-right: 31px;
}
.pr-32 {
	padding-right: 32px;
}
.pr-33 {
	padding-right: 33px;
}
.pr-34 {
	padding-right: 34px;
}
.pr-35 {
	padding-right: 35px;
}
.pr-36 {
	padding-right: 36px;
}
.pr-37 {
	padding-right: 37px;
}
.pr-38 {
	padding-right: 38px;
}
.pr-39 {
	padding-right: 39px;
}
.pr-40 {
	padding-right: 40px;
}
.pr-45 {
	padding-right: 45px;
}
.pr-50 {
	padding-right: 50px;
}
.pr-55 {
	padding-right: 55px;
}
.pr-60 {
	padding-right: 60px;
}
.pr-65 {
	padding-right: 65px;
}
.pr-70 {
	padding-right: 70px;
}
.pr-75 {
	padding-right: 75px;
}
.pr-80 {
	padding-right: 80px;
}
.pr-85 {
	padding-right: 85px;
}
.pr-90 {
	padding-right: 90px;
}
.pr-95 {
	padding-right: 95px;
}
.pr-100 {
	padding-right: 100px;
}
.pr-105 {
	padding-right: 105px;
}
.pr-110 {
	padding-right: 110px;
}
.pr-115 {
	padding-right: 115px;
}
.pr-120 {
	padding-right: 120px;
}
.pr-125 {
	padding-right: 125px;
}
.pr-130 {
	padding-right: 130px;
}
.pr-135 {
	padding-right: 135px;
}
.pr-140 {
	padding-right: 140px;
}
.pr-145 {
	padding-right: 145px;
}
.pr-150 {
	padding-right: 150px;
}
/*--------------------------
	05. margin
--------------------------*/
/* margin all */
.m-6 {
	margin: 6px;
}
.m-7 {
	margin: 7px;
}
.m-8 {
	margin: 8px;
}
.m-9 {
	margin: 9px;
}
.m-10 {
	margin: 10px;
}
.m-11 {
	margin: 11px;
}
.m-12 {
	margin: 12px;
}
.m-13 {
	margin: 13px;
}
.m-14 {
	margin: 14px;
}
.m-15 {
	margin: 15px;
}
.m-16 {
	margin: 16px;
}
.m-17 {
	margin: 17px;
}
.m-18 {
	margin: 18px;
}
.m-19 {
	margin: 19px;
}
.m-20 {
	margin: 20px;
}
.m-21 {
	margin: 21px;
}
.m-22 {
	margin: 22px;
}
.m-23 {
	margin: 23px;
}
.m-24 {
	margin: 24px;
}
.m-25 {
	margin: 25px;
}
.m-26 {
	margin: 26px;
}
.m-27 {
	margin: 27px;
}
.m-28 {
	margin: 28px;
}
.m-29 {
	margin: 29px;
}
.m-30 {
	margin: 30px;
}
.m-31 {
	margin: 31px;
}
.m-32 {
	margin: 32px;
}
.m-33 {
	margin: 33px;
}
.m-34 {
	margin: 34px;
}
.m-35 {
	margin: 35px;
}
.m-36 {
	margin: 36px;
}
.m-37 {
	margin: 37px;
}
.m-38 {
	margin: 38px;
}
.m-39 {
	margin: 39px;
}
.m-40 {
	margin: 40px;
}
.m-45 {
	margin: 45px;
}
.m-50 {
	margin: 50px;
}
.m-55 {
	margin: 55px;
}
.m-60 {
	margin: 60px;
}
.m-65 {
	margin: 65px;
}
.m-70 {
	margin: 70px;
}
.m-75 {
	margin: 75px;
}
.m-80 {
	margin: 80px;
}
.m-85 {
	margin: 85px;
}
.m-90 {
	margin: 90px;
}
.m-95 {
	margin: 95px;
}
.m-100 {
	margin: 100px;
}
.m-105 {
	margin: 105px;
}
.m-110 {
	margin: 110px;
}
.m-115 {
	margin: 115px;
}
.m-120 {
	margin: 120px;
}
.m-125 {
	margin: 125px;
}
.m-130 {
	margin: 130px;
}
.m-135 {
	margin: 135px;
}
.m-140 {
	margin: 140px;
}
.m-145 {
	margin: 145px;
}
.m-150 {
	margin: 150px;
}
/* margin top */
.mt-6 {
	margin-top: 6px;
}
.mt-7 {
	margin-top: 7px;
}
.mt-8 {
	margin-top: 8px;
}
.mt-9 {
	margin-top: 9px;
}
.mt-10 {
	margin-top: 10px;
}
.mt-11 {
	margin-top: 11px;
}
.mt-12 {
	margin-top: 12px;
}
.mt-13 {
	margin-top: 13px;
}
.mt-14 {
	margin-top: 14px;
}
.mt-15 {
	margin-top: 15px;
}
.mt-16 {
	margin-top: 16px;
}
.mt-17 {
	margin-top: 17px;
}
.mt-18 {
	margin-top: 18px;
}
.mt-19 {
	margin-top: 19px;
}
.mt-20 {
	margin-top: 20px;
}
.mt-21 {
	margin-top: 21px;
}
.mt-22 {
	margin-top: 22px;
}
.mt-23 {
	margin-top: 23px;
}
.mt-24 {
	margin-top: 24px;
}
.mt-25 {
	margin-top: 25px;
}
.mt-26 {
	margin-top: 26px;
}
.mt-27 {
	margin-top: 27px;
}
.mt-28 {
	margin-top: 28px;
}
.mt-29 {
	margin-top: 29px;
}
.mt-30 {
	margin-top: 30px;
}
.mt-31 {
	margin-top: 31px;
}
.mt-32 {
	margin-top: 32px;
}
.mt-33 {
	margin-top: 33px;
}
.mt-34 {
	margin-top: 34px;
}
.mt-35 {
	margin-top: 35px;
}
.mt-36 {
	margin-top: 36px;
}
.mt-37 {
	margin-top: 37px;
}
.mt-38 {
	margin-top: 38px;
}
.mt-39 {
	margin-top: 39px;
}
.mt-40 {
	margin-top: 40px;
}
.mt-45 {
	margin-top: 45px;
}
.mt-50 {
	margin-top: 50px;
}
.mt-55 {
	margin-top: 55px;
}
.mt-60 {
	margin-top: 60px;
}
.mt-65 {
	margin-top: 65px;
}
.mt-70 {
	margin-top: 70px;
}
.mt-75 {
	margin-top: 75px;
}
.mt-80 {
	margin-top: 80px;
}
.mt-85 {
	margin-top: 85px;
}
.mt-90 {
	margin-top: 90px;
}
.mt-95 {
	margin-top: 95px;
}
.mt-100 {
	margin-top: 100px;
}
.mt-105 {
	margin-top: 105px;
}
.mt-110 {
	margin-top: 110px;
}
.mt-115 {
	margin-top: 115px;
}
.mt-120 {
	margin-top: 120px;
}
.mt-125 {
	margin-top: 125px;
}
.mt-130 {
	margin-top: 130px;
}
.mt-135 {
	margin-top: 135px;
}
.mt-140 {
	margin-top: 140px;
}
.mt-145 {
	margin-top: 145px;
}
.mt-150 {
	margin-top: 150px;
}
/* margin bottom */
.mb-6 {
	margin-bottom: 6px;
}
.mb-7 {
	margin-bottom: 7px;
}
.mb-8 {
	margin-bottom: 8px;
}
.mb-9 {
	margin-bottom: 9px;
}
.mb-10 {
	margin-bottom: 10px;
}
.mb-11 {
	margin-bottom: 11px;
}
.mb-12 {
	margin-bottom: 12px;
}
.mb-13 {
	margin-bottom: 13px;
}
.mb-14 {
	margin-bottom: 14px;
}
.mb-15 {
	margin-bottom: 15px;
}
.mb-16 {
	margin-bottom: 16px;
}
.mb-17 {
	margin-bottom: 17px;
}
.mb-18 {
	margin-bottom: 18px;
}
.mb-19 {
	margin-bottom: 19px;
}
.mb-20 {
	margin-bottom: 20px;
}
.mb-21 {
	margin-bottom: 21px;
}
.mb-22 {
	margin-bottom: 22px;
}
.mb-23 {
	margin-bottom: 23px;
}
.mb-24 {
	margin-bottom: 24px;
}
.mb-25 {
	margin-bottom: 25px;
}
.mb-26 {
	margin-bottom: 26px;
}
.mb-27 {
	margin-bottom: 27px;
}
.mb-28 {
	margin-bottom: 28px;
}
.mb-29 {
	margin-bottom: 29px;
}
.mb-30 {
	margin-bottom: 30px;
}
.mb-31 {
	margin-bottom: 31px;
}
.mb-32 {
	margin-bottom: 32px;
}
.mb-33 {
	margin-bottom: 33px;
}
.mb-34 {
	margin-bottom: 34px;
}
.mb-35 {
	margin-bottom: 35px;
}
.mb-36 {
	margin-bottom: 36px;
}
.mb-37 {
	margin-bottom: 37px;
}
.mb-38 {
	margin-bottom: 38px;
}
.mb-39 {
	margin-bottom: 39px;
}
.mb-40 {
	margin-bottom: 40px;
}
.mb-45 {
	margin-bottom: 45px;
}
.mb-50 {
	margin-bottom: 50px;
}
.mb-55 {
	margin-bottom: 55px;
}
.mb-60 {
	margin-bottom: 60px;
}
.mb-65 {
	margin-bottom: 65px;
}
.mb-70 {
	margin-bottom: 70px;
}
.mb-75 {
	margin-bottom: 75px;
}
.mb-80 {
	margin-bottom: 80px;
}
.mb-85 {
	margin-bottom: 85px;
}
.mb-90 {
	margin-bottom: 90px;
}
.mb-95 {
	margin-bottom: 95px;
}
.mb-100 {
	margin-bottom: 100px;
}
.mb-105 {
	margin-bottom: 105px;
}
.mb-110 {
	margin-bottom: 110px;
}
.mb-115 {
	margin-bottom: 115px;
}
.mb-120 {
	margin-bottom: 120px;
}
.mb-125 {
	margin-bottom: 125px;
}
.mb-130 {
	margin-bottom: 130px;
}
.mb-135 {
	margin-bottom: 135px;
}
.mb-140 {
	margin-bottom: 140px;
}
.mb-145 {
	margin-bottom: 145px;
}
.mb-150 {
	margin-bottom: 150px;
}
/* margin left */
.ml-6 {
	margin-left: 6px;
}
.ml-7 {
	margin-left: 7px;
}
.ml-8 {
	margin-left: 8px;
}
.ml-9 {
	margin-left: 9px;
}
.ml-10 {
	margin-left: 10px;
}
.ml-11 {
	margin-left: 11px;
}
.ml-12 {
	margin-left: 12px;
}
.ml-13 {
	margin-left: 13px;
}
.ml-14 {
	margin-left: 14px;
}
.ml-15 {
	margin-left: 15px;
}
.ml-16 {
	margin-left: 16px;
}
.ml-17 {
	margin-left: 17px;
}
.ml-18 {
	margin-left: 18px;
}
.ml-19 {
	margin-left: 19px;
}
.ml-20 {
	margin-left: 20px;
}
.ml-21 {
	margin-left: 21px;
}
.ml-22 {
	margin-left: 22px;
}
.ml-23 {
	margin-left: 23px;
}
.ml-24 {
	margin-left: 24px;
}
.ml-25 {
	margin-left: 25px;
}
.ml-26 {
	margin-left: 26px;
}
.ml-27 {
	margin-left: 27px;
}
.ml-28 {
	margin-left: 28px;
}
.ml-29 {
	margin-left: 29px;
}
.ml-30 {
	margin-left: 30px;
}
.ml-31 {
	margin-left: 31px;
}
.ml-32 {
	margin-left: 32px;
}
.ml-33 {
	margin-left: 33px;
}
.ml-34 {
	margin-left: 34px;
}
.ml-35 {
	margin-left: 35px;
}
.ml-36 {
	margin-left: 36px;
}
.ml-37 {
	margin-left: 37px;
}
.ml-38 {
	margin-left: 38px;
}
.ml-39 {
	margin-left: 39px;
}
.ml-40 {
	margin-left: 40px;
}
.ml-45 {
	margin-left: 45px;
}
.ml-50 {
	margin-left: 50px;
}
.ml-55 {
	margin-left: 55px;
}
.ml-60 {
	margin-left: 60px;
}
.ml-65 {
	margin-left: 65px;
}
.ml-70 {
	margin-left: 70px;
}
.ml-75 {
	margin-left: 75px;
}
.ml-80 {
	margin-left: 80px;
}
.ml-85 {
	margin-left: 85px;
}
.ml-90 {
	margin-left: 90px;
}
.ml-95 {
	margin-left: 95px;
}
.ml-100 {
	margin-left: 100px;
}
.ml-105 {
	margin-left: 105px;
}
.ml-110 {
	margin-left: 110px;
}
.ml-115 {
	margin-left: 115px;
}
.ml-120 {
	margin-left: 120px;
}
.ml-125 {
	margin-left: 125px;
}
.ml-130 {
	margin-left: 130px;
}
.ml-135 {
	margin-left: 135px;
}
.ml-140 {
	margin-left: 140px;
}
.ml-145 {
	margin-left: 145px;
}
.ml-150 {
	margin-left: 150px;
}
/* margin right */
.mr-6 {
	margin-right: 6px;
}
.mr-7 {
	margin-right: 7px;
}
.mr-8 {
	margin-right: 8px;
}
.mr-9 {
	margin-right: 9px;
}
.mr-10 {
	margin-right: 10px;
}
.mr-11 {
	margin-right: 11px;
}
.mr-12 {
	margin-right: 12px;
}
.mr-13 {
	margin-right: 13px;
}
.mr-14 {
	margin-right: 14px;
}
.mr-15 {
	margin-right: 15px;
}
.mr-16 {
	margin-right: 16px;
}
.mr-17 {
	margin-right: 17px;
}
.mr-18 {
	margin-right: 18px;
}
.mr-19 {
	margin-right: 19px;
}
.mr-20 {
	margin-right: 20px;
}
.mr-21 {
	margin-right: 21px;
}
.mr-22 {
	margin-right: 22px;
}
.mr-23 {
	margin-right: 23px;
}
.mr-24 {
	margin-right: 24px;
}
.mr-25 {
	margin-right: 25px;
}
.mr-26 {
	margin-right: 26px;
}
.mr-27 {
	margin-right: 27px;
}
.mr-28 {
	margin-right: 28px;
}
.mr-29 {
	margin-right: 29px;
}
.mr-30 {
	margin-right: 30px;
}
.mr-31 {
	margin-right: 31px;
}
.mr-32 {
	margin-right: 32px;
}
.mr-33 {
	margin-right: 33px;
}
.mr-34 {
	margin-right: 34px;
}
.mr-35 {
	margin-right: 35px;
}
.mr-36 {
	margin-right: 36px;
}
.mr-37 {
	margin-right: 37px;
}
.mr-38 {
	margin-right: 38px;
}
.mr-39 {
	margin-right: 39px;
}
.mr-40 {
	margin-right: 40px;
}
.mr-45 {
	margin-right: 45px;
}
.mr-50 {
	margin-right: 50px;
}
.mr-55 {
	margin-right: 55px;
}
.mr-60 {
	margin-right: 60px;
}
.mr-65 {
	margin-right: 65px;
}
.mr-70 {
	margin-right: 70px;
}
.mr-75 {
	margin-right: 75px;
}
.mr-80 {
	margin-right: 80px;
}
.mr-85 {
	margin-right: 85px;
}
.mr-90 {
	margin-right: 90px;
}
.mr-95 {
	margin-right: 95px;
}
.mr-100 {
	margin-right: 100px;
}
.mr-105 {
	margin-right: 105px;
}
.mr-110 {
	margin-right: 110px;
}
.mr-115 {
	margin-right: 115px;
}
.mr-120 {
	margin-right: 120px;
}
.mr-125 {
	margin-right: 125px;
}
.mr-130 {
	margin-right: 130px;
}
.mr-135 {
	margin-right: 135px;
}
.mr-140 {
	margin-right: 140px;
}
.mr-145 {
	margin-right: 145px;
}
.mr-150 {
	margin-right: 150px;
}
/*--------------------------
	06. border
--------------------------*/
/* border width */
.border-width-2 {
	border-width: 2px;
}
.border-width-3 {
	border-width: 3px;
}
.border-width-4 {
	border-width: 4px;
}
.border-width-5 {
	border-width: 5px;
}
.border-width-6 {
	border-width: 6px;
}
.border-width-7 {
	border-width: 7px;
}
.border-width-8 {
	border-width: 8px;
}
.border-width-9 {
	border-width: 9px;
}
.border-width-10 {
	border-width: 10px;
}
/* border left width */
.border-left-width-2 {
	border-left-width: 2px !important;
}
.border-left-width-3 {
	border-left-width: 3px !important;
}
.border-left-width-4 {
	border-left-width: 4px !important;
}
.border-left-width-5 {
	border-left-width: 5px !important;
}
.border-left-width-6 {
	border-left-width: 6px !important;
}
.border-left-width-7 {
	border-left-width: 7px !important;
}
.border-left-width-8 {
	border-left-width: 8px !important;
}
.border-left-width-9 {
	border-left-width: 9px !important;
}
.border-left-width-10 {
	border-left-width: 10px !important;
}
/* border right width */
.border-right-width-2 {
	border-right-width: 2px;
}
.border-right-width-3 {
	border-right-width: 3px;
}
.border-right-width-4 {
	border-right-width: 4px;
}
.border-right-width-5 {
	border-right-width: 5px;
}
.border-right-width-6 {
	border-right-width: 6px;
}
.border-right-width-7 {
	border-right-width: 7px;
}
.border-right-width-8 {
	border-right-width: 8px;
}
.border-right-width-9 {
	border-right-width: 9px;
}
.border-right-width-10 {
	border-right-width: 10px;
}
/* border top width */
.border-top-width-2 {
	border-top-width: 2px;
}
.border-top-width-3 {
	border-top-width: 3px;
}
.border-top-width-4 {
	border-top-width: 4px;
}
.border-top-width-5 {
	border-top-width: 5px;
}
.border-top-width-6 {
	border-top-width: 6px;
}
.border-top-width-7 {
	border-top-width: 7px;
}
.border-top-width-8 {
	border-top-width: 8px;
}
.border-top-width-9 {
	border-top-width: 9px;
}
.border-top-width-10 {
	border-top-width: 10px;
}
/* border bottom width */
.border-bottom-width-2 {
	border-bottom-width: 2px;
}
.border-bottom-width-3 {
	border-bottom-width: 3px;
}
.border-bottom-width-4 {
	border-bottom-width: 4px;
}
.border-bottom-width-5 {
	border-bottom-width: 5px;
}
.border-bottom-width-6 {
	border-bottom-width: 6px;
}
.border-bottom-width-7 {
	border-bottom-width: 7px;
}
.border-bottom-width-8 {
	border-bottom-width: 8px;
}
.border-bottom-width-9 {
	border-bottom-width: 9px;
}
.border-bottom-width-10 {
	border-bottom-width: 10px;
}
/* border style */
.border-style-solid {
	border-style: solid;
}
.border-style-dashed {
	border-style: dashed;
}
.border-style-dotted {
	border-style: dotted;
}
.border-style-double {
	border-style: double;
}
`, "",{"version":3,"sources":["webpack://./src/composant/css/helper.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;;;;;;;;;;;yEAWyE;;AAEzE;;2BAE2B;AAC3B;CAIC,8BAA8B;AAC/B;AACA;CAIC,gCAAgC;AACjC;AACA;CAIC,gCAAgC;AACjC;AACA;CAIC,gCAAgC;AACjC;AACA;CAIC,gCAAgC;AACjC;AACA;CAIC,gCAAgC;AACjC;AACA;;2BAE2B;AAC3B;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;;2BAE2B;AAC3B,iBAAiB;AACjB;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA,4BAA4B;AAC5B;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;2BAE2B;AAC3B,gBAAgB;AAChB;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA,gBAAgB;AAChB;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA,mBAAmB;AACnB;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA,iBAAiB;AACjB;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA,kBAAkB;AAClB;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;;2BAE2B;AAC3B,eAAe;AACf;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA,eAAe;AACf;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA,kBAAkB;AAClB;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA,gBAAgB;AAChB;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA,iBAAiB;AACjB;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;;2BAE2B;AAC3B,iBAAiB;AACjB;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA,sBAAsB;AACtB;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,kCAAkC;AACnC;AACA,uBAAuB;AACvB;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,wBAAwB;AACzB;AACA,qBAAqB;AACrB;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,sBAAsB;AACvB;AACA,wBAAwB;AACxB;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,yBAAyB;AAC1B;AACA,iBAAiB;AACjB;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB","sourcesContent":["@charset \"utf-8\";\r\n/* CSS Document */\r\n\r\n/*========================================================================\r\n\t\r\n\tTable of contents\r\n\t\r\n\t01. Transition CSS\r\n\t02. Font Size\r\n\t03. Social icon color\r\n\t04. Padding\r\n\t05. Margin\r\n\t06. Border\r\n\r\n========================================================================*/\r\n\r\n/*--------------------------\r\n\t01. Transition CSS\r\n--------------------------*/\r\n.transition-1s {\r\n\t-webkit-transition: all 1s ease-in-out;\r\n\t-moz-transition: all 1s ease-in-out;\r\n\t-o-transition: all 1s ease-in-out;\r\n\ttransition: all 1s ease-in-out;\r\n}\r\n.transition-02s {\r\n\t-webkit-transition: all 0.2s ease-in-out;\r\n\t-moz-transition: all 0.2s ease-in-out;\r\n\t-o-transition: all 0.2s ease-in-out;\r\n\ttransition: all 0.2s ease-in-out;\r\n}\r\n.transition-03s {\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n.transition-04s {\r\n\t-webkit-transition: all 0.4s ease-in-out;\r\n\t-moz-transition: all 0.4s ease-in-out;\r\n\t-o-transition: all 0.4s ease-in-out;\r\n\ttransition: all 0.4s ease-in-out;\r\n}\r\n.transition-05s {\r\n\t-webkit-transition: all 0.5s ease-in-out;\r\n\t-moz-transition: all 0.5s ease-in-out;\r\n\t-o-transition: all 0.5s ease-in-out;\r\n\ttransition: all 0.5s ease-in-out;\r\n}\r\n.transition-06s {\r\n\t-webkit-transition: all 0.6s ease-in-out;\r\n\t-moz-transition: all 0.6s ease-in-out;\r\n\t-o-transition: all 0.6s ease-in-out;\r\n\ttransition: all 0.6s ease-in-out;\r\n}\r\n/*--------------------------\r\n\t02. Font Size\r\n--------------------------*/\r\n.font-size-12 {\r\n\tfont-size: 12px;\r\n}\r\n.font-size-13 {\r\n\tfont-size: 13px;\r\n}\r\n.font-size-14 {\r\n\tfont-size: 14px;\r\n}\r\n.font-size-15 {\r\n\tfont-size: 15px;\r\n}\r\n.font-size-16 {\r\n\tfont-size: 16px;\r\n}\r\n.font-size-17 {\r\n\tfont-size: 17px;\r\n}\r\n.font-size-18 {\r\n\tfont-size: 18px;\r\n}\r\n.font-size-19 {\r\n\tfont-size: 19px;\r\n}\r\n.font-size-20 {\r\n\tfont-size: 20px;\r\n}\r\n.font-size-21 {\r\n\tfont-size: 21px;\r\n}\r\n.font-size-22 {\r\n\tfont-size: 22px;\r\n}\r\n.font-size-23 {\r\n\tfont-size: 23px;\r\n}\r\n.font-size-24 {\r\n\tfont-size: 24px;\r\n}\r\n.font-size-25 {\r\n\tfont-size: 25px;\r\n}\r\n.font-size-26 {\r\n\tfont-size: 26px;\r\n}\r\n.font-size-27 {\r\n\tfont-size: 27px;\r\n}\r\n.font-size-28 {\r\n\tfont-size: 28px;\r\n}\r\n.font-size-29 {\r\n\tfont-size: 29px;\r\n}\r\n.font-size-30 {\r\n\tfont-size: 30px;\r\n}\r\n.font-size-31 {\r\n\tfont-size: 31px;\r\n}\r\n.font-size-32 {\r\n\tfont-size: 32px;\r\n}\r\n.font-size-33 {\r\n\tfont-size: 33px;\r\n}\r\n.font-size-34 {\r\n\tfont-size: 34px;\r\n}\r\n.font-size-35 {\r\n\tfont-size: 35px;\r\n}\r\n.font-size-36 {\r\n\tfont-size: 36px;\r\n}\r\n.font-size-37 {\r\n\tfont-size: 37px;\r\n}\r\n.font-size-38 {\r\n\tfont-size: 38px;\r\n}\r\n.font-size-39 {\r\n\tfont-size: 39px;\r\n}\r\n.font-size-40 {\r\n\tfont-size: 40px;\r\n}\r\n.font-size-41 {\r\n\tfont-size: 41px;\r\n}\r\n.font-size-42 {\r\n\tfont-size: 42px;\r\n}\r\n.font-size-43 {\r\n\tfont-size: 43px;\r\n}\r\n.font-size-44 {\r\n\tfont-size: 44px;\r\n}\r\n.font-size-45 {\r\n\tfont-size: 45px;\r\n}\r\n.font-size-46 {\r\n\tfont-size: 46px;\r\n}\r\n.font-size-47 {\r\n\tfont-size: 47px;\r\n}\r\n.font-size-48 {\r\n\tfont-size: 48px;\r\n}\r\n.font-size-49 {\r\n\tfont-size: 49px;\r\n}\r\n.font-size-50 {\r\n\tfont-size: 50px;\r\n}\r\n.font-size-51 {\r\n\tfont-size: 51px;\r\n}\r\n.font-size-52 {\r\n\tfont-size: 52px;\r\n}\r\n.font-size-53 {\r\n\tfont-size: 53px;\r\n}\r\n.font-size-54 {\r\n\tfont-size: 54px;\r\n}\r\n.font-size-55 {\r\n\tfont-size: 55px;\r\n}\r\n.font-size-56 {\r\n\tfont-size: 56px;\r\n}\r\n.font-size-57 {\r\n\tfont-size: 57px;\r\n}\r\n.font-size-58 {\r\n\tfont-size: 58px;\r\n}\r\n.font-size-59 {\r\n\tfont-size: 59px;\r\n}\r\n.font-size-60 {\r\n\tfont-size: 60px;\r\n}\r\n/*--------------------------\r\n\t03. Social icon color\r\n--------------------------*/\r\n/* Social color */\r\n.facebook-color {\r\n\tcolor: #3a559f;\r\n}\r\n.twitter-color {\r\n\tcolor: #2aaae0;\r\n}\r\n.linkedin-color {\r\n\tcolor: #007bb5;\r\n}\r\n.google-plus-color {\r\n\tcolor: #dc4335;\r\n}\r\n.pinterest-color {\r\n\tcolor: #cb2027;\r\n}\r\n.whatsapp-color {\r\n\tcolor: #0dc143;\r\n}\r\n.youtube-color {\r\n\tcolor: #e42b33;\r\n}\r\n.instagram-color {\r\n\tcolor: #c82d9e;\r\n}\r\n.skype-color {\r\n\tcolor: #31c5ed;\r\n}\r\n/* Social background color */\r\n.facebook-bg-color {\r\n\tbackground-color: #3a559f;\r\n}\r\n.twitter-bg-color {\r\n\tbackground-color: #2aaae0;\r\n}\r\n.linkedin-bg-color {\r\n\tbackground-color: #007bb5;\r\n}\r\n.google-plus-bg-color {\r\n\tbackground-color: #dc4335;\r\n}\r\n.pinterest-bg-color {\r\n\tbackground-color: #cb2027;\r\n}\r\n.whatsapp-bg-color {\r\n\tbackground-color: #0dc143;\r\n}\r\n.youtube-bg-color {\r\n\tbackground-color: #e42b33;\r\n}\r\n.instagram-bg-color {\r\n\tbackground-color: #c82d9e;\r\n}\r\n.skype-bg-color {\r\n\tbackground-color: #31c5ed;\r\n}\r\n/*--------------------------\r\n\t04. padding\r\n--------------------------*/\r\n/* padding all */\r\n.p-6 {\r\n\tpadding: 6px;\r\n}\r\n.p-7 {\r\n\tpadding: 7px;\r\n}\r\n.p-8 {\r\n\tpadding: 8px;\r\n}\r\n.p-9 {\r\n\tpadding: 9px;\r\n}\r\n.p-10 {\r\n\tpadding: 10px;\r\n}\r\n.p-11 {\r\n\tpadding: 11px;\r\n}\r\n.p-12 {\r\n\tpadding: 12px;\r\n}\r\n.p-13 {\r\n\tpadding: 13px;\r\n}\r\n.p-14 {\r\n\tpadding: 14px;\r\n}\r\n.p-15 {\r\n\tpadding: 15px;\r\n}\r\n.p-16 {\r\n\tpadding: 16px;\r\n}\r\n.p-17 {\r\n\tpadding: 17px;\r\n}\r\n.p-18 {\r\n\tpadding: 18px;\r\n}\r\n.p-19 {\r\n\tpadding: 19px;\r\n}\r\n.p-20 {\r\n\tpadding: 20px;\r\n}\r\n.p-21 {\r\n\tpadding: 21px;\r\n}\r\n.p-22 {\r\n\tpadding: 22px;\r\n}\r\n.p-23 {\r\n\tpadding: 23px;\r\n}\r\n.p-24 {\r\n\tpadding: 24px;\r\n}\r\n.p-25 {\r\n\tpadding: 25px;\r\n}\r\n.p-26 {\r\n\tpadding: 26px;\r\n}\r\n.p-27 {\r\n\tpadding: 27px;\r\n}\r\n.p-28 {\r\n\tpadding: 28px;\r\n}\r\n.p-29 {\r\n\tpadding: 29px;\r\n}\r\n.p-30 {\r\n\tpadding: 30px;\r\n}\r\n.p-31 {\r\n\tpadding: 31px;\r\n}\r\n.p-32 {\r\n\tpadding: 32px;\r\n}\r\n.p-33 {\r\n\tpadding: 33px;\r\n}\r\n.p-34 {\r\n\tpadding: 34px;\r\n}\r\n.p-35 {\r\n\tpadding: 35px;\r\n}\r\n.p-36 {\r\n\tpadding: 36px;\r\n}\r\n.p-37 {\r\n\tpadding: 37px;\r\n}\r\n.p-38 {\r\n\tpadding: 38px;\r\n}\r\n.p-39 {\r\n\tpadding: 39px;\r\n}\r\n.p-40 {\r\n\tpadding: 40px;\r\n}\r\n.p-45 {\r\n\tpadding: 45px;\r\n}\r\n.p-50 {\r\n\tpadding: 50px;\r\n}\r\n.p-55 {\r\n\tpadding: 55px;\r\n}\r\n.p-60 {\r\n\tpadding: 60px;\r\n}\r\n.p-65 {\r\n\tpadding: 65px;\r\n}\r\n.p-70 {\r\n\tpadding: 70px;\r\n}\r\n.p-75 {\r\n\tpadding: 75px;\r\n}\r\n.p-80 {\r\n\tpadding: 80px;\r\n}\r\n.p-85 {\r\n\tpadding: 85px;\r\n}\r\n.p-90 {\r\n\tpadding: 90px;\r\n}\r\n.p-95 {\r\n\tpadding: 95px;\r\n}\r\n.p-100 {\r\n\tpadding: 100px;\r\n}\r\n.p-105 {\r\n\tpadding: 105px;\r\n}\r\n.p-110 {\r\n\tpadding: 110px;\r\n}\r\n.p-115 {\r\n\tpadding: 115px;\r\n}\r\n.p-120 {\r\n\tpadding: 120px;\r\n}\r\n.p-125 {\r\n\tpadding: 125px;\r\n}\r\n.p-130 {\r\n\tpadding: 135px;\r\n}\r\n.p-135 {\r\n\tpadding: 135px;\r\n}\r\n.p-140 {\r\n\tpadding: 140px;\r\n}\r\n.p-145 {\r\n\tpadding: 145px;\r\n}\r\n.p-150 {\r\n\tpadding: 150px;\r\n}\r\n/* padding top */\r\n.pt-6 {\r\n\tpadding-top: 6px;\r\n}\r\n.pt-7 {\r\n\tpadding-top: 7px;\r\n}\r\n.pt-8 {\r\n\tpadding-top: 8px;\r\n}\r\n.pt-9 {\r\n\tpadding-top: 9px;\r\n}\r\n.pt-10 {\r\n\tpadding-top: 10px;\r\n}\r\n.pt-11 {\r\n\tpadding-top: 11px;\r\n}\r\n.pt-12 {\r\n\tpadding-top: 12px;\r\n}\r\n.pt-13 {\r\n\tpadding-top: 13px;\r\n}\r\n.pt-14 {\r\n\tpadding-top: 14px;\r\n}\r\n.pt-15 {\r\n\tpadding-top: 15px;\r\n}\r\n.pt-16 {\r\n\tpadding-top: 16px;\r\n}\r\n.pt-17 {\r\n\tpadding-top: 17px;\r\n}\r\n.pt-18 {\r\n\tpadding-top: 18px;\r\n}\r\n.pt-19 {\r\n\tpadding-top: 19px;\r\n}\r\n.pt-20 {\r\n\tpadding-top: 20px;\r\n}\r\n.pt-21 {\r\n\tpadding-top: 21px;\r\n}\r\n.pt-22 {\r\n\tpadding-top: 22px;\r\n}\r\n.pt-23 {\r\n\tpadding-top: 23px;\r\n}\r\n.pt-24 {\r\n\tpadding-top: 24px;\r\n}\r\n.pt-25 {\r\n\tpadding-top: 25px;\r\n}\r\n.pt-26 {\r\n\tpadding-top: 26px;\r\n}\r\n.pt-27 {\r\n\tpadding-top: 27px;\r\n}\r\n.pt-28 {\r\n\tpadding-top: 28px;\r\n}\r\n.pt-29 {\r\n\tpadding-top: 29px;\r\n}\r\n.pt-30 {\r\n\tpadding-top: 30px;\r\n}\r\n.pt-31 {\r\n\tpadding-top: 31px;\r\n}\r\n.pt-32 {\r\n\tpadding-top: 32px;\r\n}\r\n.pt-33 {\r\n\tpadding-top: 33px;\r\n}\r\n.pt-34 {\r\n\tpadding-top: 34px;\r\n}\r\n.pt-35 {\r\n\tpadding-top: 35px;\r\n}\r\n.pt-36 {\r\n\tpadding-top: 36px;\r\n}\r\n.pt-37 {\r\n\tpadding-top: 37px;\r\n}\r\n.pt-38 {\r\n\tpadding-top: 38px;\r\n}\r\n.pt-39 {\r\n\tpadding-top: 39px;\r\n}\r\n.pt-40 {\r\n\tpadding-top: 40px;\r\n}\r\n.pt-45 {\r\n\tpadding-top: 45px;\r\n}\r\n.pt-50 {\r\n\tpadding-top: 50px;\r\n}\r\n.pt-55 {\r\n\tpadding-top: 55px;\r\n}\r\n.pt-60 {\r\n\tpadding-top: 60px;\r\n}\r\n.pt-65 {\r\n\tpadding-top: 65px;\r\n}\r\n.pt-70 {\r\n\tpadding-top: 70px;\r\n}\r\n.pt-75 {\r\n\tpadding-top: 75px;\r\n}\r\n.pt-80 {\r\n\tpadding-top: 80px;\r\n}\r\n.pt-85 {\r\n\tpadding-top: 85px;\r\n}\r\n.pt-90 {\r\n\tpadding-top: 90px;\r\n}\r\n.pt-95 {\r\n\tpadding-top: 95px;\r\n}\r\n.pt-100 {\r\n\tpadding-top: 100px;\r\n}\r\n.pt-105 {\r\n\tpadding-top: 105px;\r\n}\r\n.pt-110 {\r\n\tpadding-top: 110px;\r\n}\r\n.pt-115 {\r\n\tpadding-top: 115px;\r\n}\r\n.pt-120 {\r\n\tpadding-top: 120px;\r\n}\r\n.pt-125 {\r\n\tpadding-top: 125px;\r\n}\r\n.pt-130 {\r\n\tpadding-top: 130px;\r\n}\r\n.pt-135 {\r\n\tpadding-top: 135px;\r\n}\r\n.pt-140 {\r\n\tpadding-top: 140px;\r\n}\r\n.pt-145 {\r\n\tpadding-top: 145px;\r\n}\r\n.pt-150 {\r\n\tpadding-top: 150px;\r\n}\r\n/* padding bottom */\r\n.pb-6 {\r\n\tpadding-bottom: 6px;\r\n}\r\n.pb-7 {\r\n\tpadding-bottom: 7px;\r\n}\r\n.pb-8 {\r\n\tpadding-bottom: 8px;\r\n}\r\n.pb-9 {\r\n\tpadding-bottom: 9px;\r\n}\r\n.pb-10 {\r\n\tpadding-bottom: 10px;\r\n}\r\n.pb-11 {\r\n\tpadding-bottom: 11px;\r\n}\r\n.pb-12 {\r\n\tpadding-bottom: 12px;\r\n}\r\n.pb-13 {\r\n\tpadding-bottom: 13px;\r\n}\r\n.pb-14 {\r\n\tpadding-bottom: 14px;\r\n}\r\n.pb-15 {\r\n\tpadding-bottom: 15px;\r\n}\r\n.pb-16 {\r\n\tpadding-bottom: 16px;\r\n}\r\n.pb-17 {\r\n\tpadding-bottom: 17px;\r\n}\r\n.pb-18 {\r\n\tpadding-bottom: 18px;\r\n}\r\n.pb-19 {\r\n\tpadding-bottom: 19px;\r\n}\r\n.pb-20 {\r\n\tpadding-bottom: 20px;\r\n}\r\n.pb-21 {\r\n\tpadding-bottom: 21px;\r\n}\r\n.pb-22 {\r\n\tpadding-bottom: 22px;\r\n}\r\n.pb-23 {\r\n\tpadding-bottom: 23px;\r\n}\r\n.pb-24 {\r\n\tpadding-bottom: 24px;\r\n}\r\n.pb-25 {\r\n\tpadding-bottom: 25px;\r\n}\r\n.pb-26 {\r\n\tpadding-bottom: 26px;\r\n}\r\n.pb-27 {\r\n\tpadding-bottom: 27px;\r\n}\r\n.pb-28 {\r\n\tpadding-bottom: 28px;\r\n}\r\n.pb-29 {\r\n\tpadding-bottom: 29px;\r\n}\r\n.pb-30 {\r\n\tpadding-bottom: 30px;\r\n}\r\n.pb-31 {\r\n\tpadding-bottom: 31px;\r\n}\r\n.pb-32 {\r\n\tpadding-bottom: 32px;\r\n}\r\n.pb-33 {\r\n\tpadding-bottom: 33px;\r\n}\r\n.pb-34 {\r\n\tpadding-bottom: 34px;\r\n}\r\n.pb-35 {\r\n\tpadding-bottom: 35px;\r\n}\r\n.pb-36 {\r\n\tpadding-bottom: 36px;\r\n}\r\n.pb-37 {\r\n\tpadding-bottom: 37px;\r\n}\r\n.pb-38 {\r\n\tpadding-bottom: 38px;\r\n}\r\n.pb-39 {\r\n\tpadding-bottom: 39px;\r\n}\r\n.pb-40 {\r\n\tpadding-bottom: 40px;\r\n}\r\n.pb-45 {\r\n\tpadding-bottom: 45px;\r\n}\r\n.pb-50 {\r\n\tpadding-bottom: 50px;\r\n}\r\n.pb-55 {\r\n\tpadding-bottom: 55px;\r\n}\r\n.pb-60 {\r\n\tpadding-bottom: 60px;\r\n}\r\n.pb-65 {\r\n\tpadding-bottom: 65px;\r\n}\r\n.pb-70 {\r\n\tpadding-bottom: 70px;\r\n}\r\n.pb-75 {\r\n\tpadding-bottom: 75px;\r\n}\r\n.pb-80 {\r\n\tpadding-bottom: 80px;\r\n}\r\n.pb-85 {\r\n\tpadding-bottom: 85px;\r\n}\r\n.pb-90 {\r\n\tpadding-bottom: 90px;\r\n}\r\n.pb-95 {\r\n\tpadding-bottom: 95px;\r\n}\r\n.pb-100 {\r\n\tpadding-bottom: 100px;\r\n}\r\n.pb-105 {\r\n\tpadding-bottom: 105px;\r\n}\r\n.pb-110 {\r\n\tpadding-bottom: 110px;\r\n}\r\n.pb-115 {\r\n\tpadding-bottom: 115px;\r\n}\r\n.pb-120 {\r\n\tpadding-bottom: 120px;\r\n}\r\n.pb-125 {\r\n\tpadding-bottom: 125px;\r\n}\r\n.pb-130 {\r\n\tpadding-bottom: 130px;\r\n}\r\n.pb-135 {\r\n\tpadding-bottom: 135px;\r\n}\r\n.pb-140 {\r\n\tpadding-bottom: 140px;\r\n}\r\n.pb-145 {\r\n\tpadding-bottom: 145px;\r\n}\r\n.pb-150 {\r\n\tpadding-bottom: 150px;\r\n}\r\n/* padding left */\r\n.pl-6 {\r\n\tpadding-left: 6px;\r\n}\r\n.pl-7 {\r\n\tpadding-left: 7px;\r\n}\r\n.pl-8 {\r\n\tpadding-left: 8px;\r\n}\r\n.pl-9 {\r\n\tpadding-left: 9px;\r\n}\r\n.pl-10 {\r\n\tpadding-left: 10px;\r\n}\r\n.pl-11 {\r\n\tpadding-left: 11px;\r\n}\r\n.pl-12 {\r\n\tpadding-left: 12px;\r\n}\r\n.pl-13 {\r\n\tpadding-left: 13px;\r\n}\r\n.pl-14 {\r\n\tpadding-left: 14px;\r\n}\r\n.pl-15 {\r\n\tpadding-left: 15px;\r\n}\r\n.pl-16 {\r\n\tpadding-left: 16px;\r\n}\r\n.pl-17 {\r\n\tpadding-left: 17px;\r\n}\r\n.pl-18 {\r\n\tpadding-left: 18px;\r\n}\r\n.pl-19 {\r\n\tpadding-left: 19px;\r\n}\r\n.pl-20 {\r\n\tpadding-left: 20px;\r\n}\r\n.pl-21 {\r\n\tpadding-left: 21px;\r\n}\r\n.pl-22 {\r\n\tpadding-left: 22px;\r\n}\r\n.pl-23 {\r\n\tpadding-left: 23px;\r\n}\r\n.pl-24 {\r\n\tpadding-left: 24px;\r\n}\r\n.pl-25 {\r\n\tpadding-left: 25px;\r\n}\r\n.pl-26 {\r\n\tpadding-left: 26px;\r\n}\r\n.pl-27 {\r\n\tpadding-left: 27px;\r\n}\r\n.pl-28 {\r\n\tpadding-left: 28px;\r\n}\r\n.pl-29 {\r\n\tpadding-left: 29px;\r\n}\r\n.pl-30 {\r\n\tpadding-left: 30px;\r\n}\r\n.pl-31 {\r\n\tpadding-left: 31px;\r\n}\r\n.pl-32 {\r\n\tpadding-left: 32px;\r\n}\r\n.pl-33 {\r\n\tpadding-left: 33px;\r\n}\r\n.pl-34 {\r\n\tpadding-left: 34px;\r\n}\r\n.pl-35 {\r\n\tpadding-left: 35px;\r\n}\r\n.pl-36 {\r\n\tpadding-left: 36px;\r\n}\r\n.pl-37 {\r\n\tpadding-left: 37px;\r\n}\r\n.pl-38 {\r\n\tpadding-left: 38px;\r\n}\r\n.pl-39 {\r\n\tpadding-left: 39px;\r\n}\r\n.pl-40 {\r\n\tpadding-left: 40px;\r\n}\r\n.pl-45 {\r\n\tpadding-left: 45px;\r\n}\r\n.pl-50 {\r\n\tpadding-left: 50px;\r\n}\r\n.pl-55 {\r\n\tpadding-left: 55px;\r\n}\r\n.pl-60 {\r\n\tpadding-left: 60px;\r\n}\r\n.pl-65 {\r\n\tpadding-left: 65px;\r\n}\r\n.pl-70 {\r\n\tpadding-left: 70px;\r\n}\r\n.pl-75 {\r\n\tpadding-left: 75px;\r\n}\r\n.pl-80 {\r\n\tpadding-left: 80px;\r\n}\r\n.pl-85 {\r\n\tpadding-left: 85px;\r\n}\r\n.pl-90 {\r\n\tpadding-left: 90px;\r\n}\r\n.pl-95 {\r\n\tpadding-left: 95px;\r\n}\r\n.pl-100 {\r\n\tpadding-left: 100px;\r\n}\r\n.pl-105 {\r\n\tpadding-left: 105px;\r\n}\r\n.pl-110 {\r\n\tpadding-left: 110px;\r\n}\r\n.pl-115 {\r\n\tpadding-left: 115px;\r\n}\r\n.pl-120 {\r\n\tpadding-left: 120px;\r\n}\r\n.pl-125 {\r\n\tpadding-left: 125px;\r\n}\r\n.pl-130 {\r\n\tpadding-left: 130px;\r\n}\r\n.pl-135 {\r\n\tpadding-left: 135px;\r\n}\r\n.pl-140 {\r\n\tpadding-left: 140px;\r\n}\r\n.pl-145 {\r\n\tpadding-left: 145px;\r\n}\r\n.pl-150 {\r\n\tpadding-left: 150px;\r\n}\r\n/* padding right */\r\n.pr-6 {\r\n\tpadding-right: 6px;\r\n}\r\n.pr-7 {\r\n\tpadding-right: 7px;\r\n}\r\n.pr-8 {\r\n\tpadding-right: 8px;\r\n}\r\n.pr-9 {\r\n\tpadding-right: 9px;\r\n}\r\n.pr-10 {\r\n\tpadding-right: 10px;\r\n}\r\n.pr-11 {\r\n\tpadding-right: 11px;\r\n}\r\n.pr-12 {\r\n\tpadding-right: 12px;\r\n}\r\n.pr-13 {\r\n\tpadding-right: 13px;\r\n}\r\n.pr-14 {\r\n\tpadding-right: 14px;\r\n}\r\n.pr-15 {\r\n\tpadding-right: 15px;\r\n}\r\n.pr-16 {\r\n\tpadding-right: 16px;\r\n}\r\n.pr-17 {\r\n\tpadding-right: 17px;\r\n}\r\n.pr-18 {\r\n\tpadding-right: 18px;\r\n}\r\n.pr-19 {\r\n\tpadding-right: 19px;\r\n}\r\n.pr-20 {\r\n\tpadding-right: 20px;\r\n}\r\n.pr-21 {\r\n\tpadding-right: 21px;\r\n}\r\n.pr-22 {\r\n\tpadding-right: 22px;\r\n}\r\n.pr-23 {\r\n\tpadding-right: 23px;\r\n}\r\n.pr-24 {\r\n\tpadding-right: 24px;\r\n}\r\n.pr-25 {\r\n\tpadding-right: 25px;\r\n}\r\n.pr-26 {\r\n\tpadding-right: 26px;\r\n}\r\n.pr-27 {\r\n\tpadding-right: 27px;\r\n}\r\n.pr-28 {\r\n\tpadding-right: 28px;\r\n}\r\n.pr-29 {\r\n\tpadding-right: 29px;\r\n}\r\n.pr-30 {\r\n\tpadding-right: 30px;\r\n}\r\n.pr-31 {\r\n\tpadding-right: 31px;\r\n}\r\n.pr-32 {\r\n\tpadding-right: 32px;\r\n}\r\n.pr-33 {\r\n\tpadding-right: 33px;\r\n}\r\n.pr-34 {\r\n\tpadding-right: 34px;\r\n}\r\n.pr-35 {\r\n\tpadding-right: 35px;\r\n}\r\n.pr-36 {\r\n\tpadding-right: 36px;\r\n}\r\n.pr-37 {\r\n\tpadding-right: 37px;\r\n}\r\n.pr-38 {\r\n\tpadding-right: 38px;\r\n}\r\n.pr-39 {\r\n\tpadding-right: 39px;\r\n}\r\n.pr-40 {\r\n\tpadding-right: 40px;\r\n}\r\n.pr-45 {\r\n\tpadding-right: 45px;\r\n}\r\n.pr-50 {\r\n\tpadding-right: 50px;\r\n}\r\n.pr-55 {\r\n\tpadding-right: 55px;\r\n}\r\n.pr-60 {\r\n\tpadding-right: 60px;\r\n}\r\n.pr-65 {\r\n\tpadding-right: 65px;\r\n}\r\n.pr-70 {\r\n\tpadding-right: 70px;\r\n}\r\n.pr-75 {\r\n\tpadding-right: 75px;\r\n}\r\n.pr-80 {\r\n\tpadding-right: 80px;\r\n}\r\n.pr-85 {\r\n\tpadding-right: 85px;\r\n}\r\n.pr-90 {\r\n\tpadding-right: 90px;\r\n}\r\n.pr-95 {\r\n\tpadding-right: 95px;\r\n}\r\n.pr-100 {\r\n\tpadding-right: 100px;\r\n}\r\n.pr-105 {\r\n\tpadding-right: 105px;\r\n}\r\n.pr-110 {\r\n\tpadding-right: 110px;\r\n}\r\n.pr-115 {\r\n\tpadding-right: 115px;\r\n}\r\n.pr-120 {\r\n\tpadding-right: 120px;\r\n}\r\n.pr-125 {\r\n\tpadding-right: 125px;\r\n}\r\n.pr-130 {\r\n\tpadding-right: 130px;\r\n}\r\n.pr-135 {\r\n\tpadding-right: 135px;\r\n}\r\n.pr-140 {\r\n\tpadding-right: 140px;\r\n}\r\n.pr-145 {\r\n\tpadding-right: 145px;\r\n}\r\n.pr-150 {\r\n\tpadding-right: 150px;\r\n}\r\n/*--------------------------\r\n\t05. margin\r\n--------------------------*/\r\n/* margin all */\r\n.m-6 {\r\n\tmargin: 6px;\r\n}\r\n.m-7 {\r\n\tmargin: 7px;\r\n}\r\n.m-8 {\r\n\tmargin: 8px;\r\n}\r\n.m-9 {\r\n\tmargin: 9px;\r\n}\r\n.m-10 {\r\n\tmargin: 10px;\r\n}\r\n.m-11 {\r\n\tmargin: 11px;\r\n}\r\n.m-12 {\r\n\tmargin: 12px;\r\n}\r\n.m-13 {\r\n\tmargin: 13px;\r\n}\r\n.m-14 {\r\n\tmargin: 14px;\r\n}\r\n.m-15 {\r\n\tmargin: 15px;\r\n}\r\n.m-16 {\r\n\tmargin: 16px;\r\n}\r\n.m-17 {\r\n\tmargin: 17px;\r\n}\r\n.m-18 {\r\n\tmargin: 18px;\r\n}\r\n.m-19 {\r\n\tmargin: 19px;\r\n}\r\n.m-20 {\r\n\tmargin: 20px;\r\n}\r\n.m-21 {\r\n\tmargin: 21px;\r\n}\r\n.m-22 {\r\n\tmargin: 22px;\r\n}\r\n.m-23 {\r\n\tmargin: 23px;\r\n}\r\n.m-24 {\r\n\tmargin: 24px;\r\n}\r\n.m-25 {\r\n\tmargin: 25px;\r\n}\r\n.m-26 {\r\n\tmargin: 26px;\r\n}\r\n.m-27 {\r\n\tmargin: 27px;\r\n}\r\n.m-28 {\r\n\tmargin: 28px;\r\n}\r\n.m-29 {\r\n\tmargin: 29px;\r\n}\r\n.m-30 {\r\n\tmargin: 30px;\r\n}\r\n.m-31 {\r\n\tmargin: 31px;\r\n}\r\n.m-32 {\r\n\tmargin: 32px;\r\n}\r\n.m-33 {\r\n\tmargin: 33px;\r\n}\r\n.m-34 {\r\n\tmargin: 34px;\r\n}\r\n.m-35 {\r\n\tmargin: 35px;\r\n}\r\n.m-36 {\r\n\tmargin: 36px;\r\n}\r\n.m-37 {\r\n\tmargin: 37px;\r\n}\r\n.m-38 {\r\n\tmargin: 38px;\r\n}\r\n.m-39 {\r\n\tmargin: 39px;\r\n}\r\n.m-40 {\r\n\tmargin: 40px;\r\n}\r\n.m-45 {\r\n\tmargin: 45px;\r\n}\r\n.m-50 {\r\n\tmargin: 50px;\r\n}\r\n.m-55 {\r\n\tmargin: 55px;\r\n}\r\n.m-60 {\r\n\tmargin: 60px;\r\n}\r\n.m-65 {\r\n\tmargin: 65px;\r\n}\r\n.m-70 {\r\n\tmargin: 70px;\r\n}\r\n.m-75 {\r\n\tmargin: 75px;\r\n}\r\n.m-80 {\r\n\tmargin: 80px;\r\n}\r\n.m-85 {\r\n\tmargin: 85px;\r\n}\r\n.m-90 {\r\n\tmargin: 90px;\r\n}\r\n.m-95 {\r\n\tmargin: 95px;\r\n}\r\n.m-100 {\r\n\tmargin: 100px;\r\n}\r\n.m-105 {\r\n\tmargin: 105px;\r\n}\r\n.m-110 {\r\n\tmargin: 110px;\r\n}\r\n.m-115 {\r\n\tmargin: 115px;\r\n}\r\n.m-120 {\r\n\tmargin: 120px;\r\n}\r\n.m-125 {\r\n\tmargin: 125px;\r\n}\r\n.m-130 {\r\n\tmargin: 130px;\r\n}\r\n.m-135 {\r\n\tmargin: 135px;\r\n}\r\n.m-140 {\r\n\tmargin: 140px;\r\n}\r\n.m-145 {\r\n\tmargin: 145px;\r\n}\r\n.m-150 {\r\n\tmargin: 150px;\r\n}\r\n/* margin top */\r\n.mt-6 {\r\n\tmargin-top: 6px;\r\n}\r\n.mt-7 {\r\n\tmargin-top: 7px;\r\n}\r\n.mt-8 {\r\n\tmargin-top: 8px;\r\n}\r\n.mt-9 {\r\n\tmargin-top: 9px;\r\n}\r\n.mt-10 {\r\n\tmargin-top: 10px;\r\n}\r\n.mt-11 {\r\n\tmargin-top: 11px;\r\n}\r\n.mt-12 {\r\n\tmargin-top: 12px;\r\n}\r\n.mt-13 {\r\n\tmargin-top: 13px;\r\n}\r\n.mt-14 {\r\n\tmargin-top: 14px;\r\n}\r\n.mt-15 {\r\n\tmargin-top: 15px;\r\n}\r\n.mt-16 {\r\n\tmargin-top: 16px;\r\n}\r\n.mt-17 {\r\n\tmargin-top: 17px;\r\n}\r\n.mt-18 {\r\n\tmargin-top: 18px;\r\n}\r\n.mt-19 {\r\n\tmargin-top: 19px;\r\n}\r\n.mt-20 {\r\n\tmargin-top: 20px;\r\n}\r\n.mt-21 {\r\n\tmargin-top: 21px;\r\n}\r\n.mt-22 {\r\n\tmargin-top: 22px;\r\n}\r\n.mt-23 {\r\n\tmargin-top: 23px;\r\n}\r\n.mt-24 {\r\n\tmargin-top: 24px;\r\n}\r\n.mt-25 {\r\n\tmargin-top: 25px;\r\n}\r\n.mt-26 {\r\n\tmargin-top: 26px;\r\n}\r\n.mt-27 {\r\n\tmargin-top: 27px;\r\n}\r\n.mt-28 {\r\n\tmargin-top: 28px;\r\n}\r\n.mt-29 {\r\n\tmargin-top: 29px;\r\n}\r\n.mt-30 {\r\n\tmargin-top: 30px;\r\n}\r\n.mt-31 {\r\n\tmargin-top: 31px;\r\n}\r\n.mt-32 {\r\n\tmargin-top: 32px;\r\n}\r\n.mt-33 {\r\n\tmargin-top: 33px;\r\n}\r\n.mt-34 {\r\n\tmargin-top: 34px;\r\n}\r\n.mt-35 {\r\n\tmargin-top: 35px;\r\n}\r\n.mt-36 {\r\n\tmargin-top: 36px;\r\n}\r\n.mt-37 {\r\n\tmargin-top: 37px;\r\n}\r\n.mt-38 {\r\n\tmargin-top: 38px;\r\n}\r\n.mt-39 {\r\n\tmargin-top: 39px;\r\n}\r\n.mt-40 {\r\n\tmargin-top: 40px;\r\n}\r\n.mt-45 {\r\n\tmargin-top: 45px;\r\n}\r\n.mt-50 {\r\n\tmargin-top: 50px;\r\n}\r\n.mt-55 {\r\n\tmargin-top: 55px;\r\n}\r\n.mt-60 {\r\n\tmargin-top: 60px;\r\n}\r\n.mt-65 {\r\n\tmargin-top: 65px;\r\n}\r\n.mt-70 {\r\n\tmargin-top: 70px;\r\n}\r\n.mt-75 {\r\n\tmargin-top: 75px;\r\n}\r\n.mt-80 {\r\n\tmargin-top: 80px;\r\n}\r\n.mt-85 {\r\n\tmargin-top: 85px;\r\n}\r\n.mt-90 {\r\n\tmargin-top: 90px;\r\n}\r\n.mt-95 {\r\n\tmargin-top: 95px;\r\n}\r\n.mt-100 {\r\n\tmargin-top: 100px;\r\n}\r\n.mt-105 {\r\n\tmargin-top: 105px;\r\n}\r\n.mt-110 {\r\n\tmargin-top: 110px;\r\n}\r\n.mt-115 {\r\n\tmargin-top: 115px;\r\n}\r\n.mt-120 {\r\n\tmargin-top: 120px;\r\n}\r\n.mt-125 {\r\n\tmargin-top: 125px;\r\n}\r\n.mt-130 {\r\n\tmargin-top: 130px;\r\n}\r\n.mt-135 {\r\n\tmargin-top: 135px;\r\n}\r\n.mt-140 {\r\n\tmargin-top: 140px;\r\n}\r\n.mt-145 {\r\n\tmargin-top: 145px;\r\n}\r\n.mt-150 {\r\n\tmargin-top: 150px;\r\n}\r\n/* margin bottom */\r\n.mb-6 {\r\n\tmargin-bottom: 6px;\r\n}\r\n.mb-7 {\r\n\tmargin-bottom: 7px;\r\n}\r\n.mb-8 {\r\n\tmargin-bottom: 8px;\r\n}\r\n.mb-9 {\r\n\tmargin-bottom: 9px;\r\n}\r\n.mb-10 {\r\n\tmargin-bottom: 10px;\r\n}\r\n.mb-11 {\r\n\tmargin-bottom: 11px;\r\n}\r\n.mb-12 {\r\n\tmargin-bottom: 12px;\r\n}\r\n.mb-13 {\r\n\tmargin-bottom: 13px;\r\n}\r\n.mb-14 {\r\n\tmargin-bottom: 14px;\r\n}\r\n.mb-15 {\r\n\tmargin-bottom: 15px;\r\n}\r\n.mb-16 {\r\n\tmargin-bottom: 16px;\r\n}\r\n.mb-17 {\r\n\tmargin-bottom: 17px;\r\n}\r\n.mb-18 {\r\n\tmargin-bottom: 18px;\r\n}\r\n.mb-19 {\r\n\tmargin-bottom: 19px;\r\n}\r\n.mb-20 {\r\n\tmargin-bottom: 20px;\r\n}\r\n.mb-21 {\r\n\tmargin-bottom: 21px;\r\n}\r\n.mb-22 {\r\n\tmargin-bottom: 22px;\r\n}\r\n.mb-23 {\r\n\tmargin-bottom: 23px;\r\n}\r\n.mb-24 {\r\n\tmargin-bottom: 24px;\r\n}\r\n.mb-25 {\r\n\tmargin-bottom: 25px;\r\n}\r\n.mb-26 {\r\n\tmargin-bottom: 26px;\r\n}\r\n.mb-27 {\r\n\tmargin-bottom: 27px;\r\n}\r\n.mb-28 {\r\n\tmargin-bottom: 28px;\r\n}\r\n.mb-29 {\r\n\tmargin-bottom: 29px;\r\n}\r\n.mb-30 {\r\n\tmargin-bottom: 30px;\r\n}\r\n.mb-31 {\r\n\tmargin-bottom: 31px;\r\n}\r\n.mb-32 {\r\n\tmargin-bottom: 32px;\r\n}\r\n.mb-33 {\r\n\tmargin-bottom: 33px;\r\n}\r\n.mb-34 {\r\n\tmargin-bottom: 34px;\r\n}\r\n.mb-35 {\r\n\tmargin-bottom: 35px;\r\n}\r\n.mb-36 {\r\n\tmargin-bottom: 36px;\r\n}\r\n.mb-37 {\r\n\tmargin-bottom: 37px;\r\n}\r\n.mb-38 {\r\n\tmargin-bottom: 38px;\r\n}\r\n.mb-39 {\r\n\tmargin-bottom: 39px;\r\n}\r\n.mb-40 {\r\n\tmargin-bottom: 40px;\r\n}\r\n.mb-45 {\r\n\tmargin-bottom: 45px;\r\n}\r\n.mb-50 {\r\n\tmargin-bottom: 50px;\r\n}\r\n.mb-55 {\r\n\tmargin-bottom: 55px;\r\n}\r\n.mb-60 {\r\n\tmargin-bottom: 60px;\r\n}\r\n.mb-65 {\r\n\tmargin-bottom: 65px;\r\n}\r\n.mb-70 {\r\n\tmargin-bottom: 70px;\r\n}\r\n.mb-75 {\r\n\tmargin-bottom: 75px;\r\n}\r\n.mb-80 {\r\n\tmargin-bottom: 80px;\r\n}\r\n.mb-85 {\r\n\tmargin-bottom: 85px;\r\n}\r\n.mb-90 {\r\n\tmargin-bottom: 90px;\r\n}\r\n.mb-95 {\r\n\tmargin-bottom: 95px;\r\n}\r\n.mb-100 {\r\n\tmargin-bottom: 100px;\r\n}\r\n.mb-105 {\r\n\tmargin-bottom: 105px;\r\n}\r\n.mb-110 {\r\n\tmargin-bottom: 110px;\r\n}\r\n.mb-115 {\r\n\tmargin-bottom: 115px;\r\n}\r\n.mb-120 {\r\n\tmargin-bottom: 120px;\r\n}\r\n.mb-125 {\r\n\tmargin-bottom: 125px;\r\n}\r\n.mb-130 {\r\n\tmargin-bottom: 130px;\r\n}\r\n.mb-135 {\r\n\tmargin-bottom: 135px;\r\n}\r\n.mb-140 {\r\n\tmargin-bottom: 140px;\r\n}\r\n.mb-145 {\r\n\tmargin-bottom: 145px;\r\n}\r\n.mb-150 {\r\n\tmargin-bottom: 150px;\r\n}\r\n/* margin left */\r\n.ml-6 {\r\n\tmargin-left: 6px;\r\n}\r\n.ml-7 {\r\n\tmargin-left: 7px;\r\n}\r\n.ml-8 {\r\n\tmargin-left: 8px;\r\n}\r\n.ml-9 {\r\n\tmargin-left: 9px;\r\n}\r\n.ml-10 {\r\n\tmargin-left: 10px;\r\n}\r\n.ml-11 {\r\n\tmargin-left: 11px;\r\n}\r\n.ml-12 {\r\n\tmargin-left: 12px;\r\n}\r\n.ml-13 {\r\n\tmargin-left: 13px;\r\n}\r\n.ml-14 {\r\n\tmargin-left: 14px;\r\n}\r\n.ml-15 {\r\n\tmargin-left: 15px;\r\n}\r\n.ml-16 {\r\n\tmargin-left: 16px;\r\n}\r\n.ml-17 {\r\n\tmargin-left: 17px;\r\n}\r\n.ml-18 {\r\n\tmargin-left: 18px;\r\n}\r\n.ml-19 {\r\n\tmargin-left: 19px;\r\n}\r\n.ml-20 {\r\n\tmargin-left: 20px;\r\n}\r\n.ml-21 {\r\n\tmargin-left: 21px;\r\n}\r\n.ml-22 {\r\n\tmargin-left: 22px;\r\n}\r\n.ml-23 {\r\n\tmargin-left: 23px;\r\n}\r\n.ml-24 {\r\n\tmargin-left: 24px;\r\n}\r\n.ml-25 {\r\n\tmargin-left: 25px;\r\n}\r\n.ml-26 {\r\n\tmargin-left: 26px;\r\n}\r\n.ml-27 {\r\n\tmargin-left: 27px;\r\n}\r\n.ml-28 {\r\n\tmargin-left: 28px;\r\n}\r\n.ml-29 {\r\n\tmargin-left: 29px;\r\n}\r\n.ml-30 {\r\n\tmargin-left: 30px;\r\n}\r\n.ml-31 {\r\n\tmargin-left: 31px;\r\n}\r\n.ml-32 {\r\n\tmargin-left: 32px;\r\n}\r\n.ml-33 {\r\n\tmargin-left: 33px;\r\n}\r\n.ml-34 {\r\n\tmargin-left: 34px;\r\n}\r\n.ml-35 {\r\n\tmargin-left: 35px;\r\n}\r\n.ml-36 {\r\n\tmargin-left: 36px;\r\n}\r\n.ml-37 {\r\n\tmargin-left: 37px;\r\n}\r\n.ml-38 {\r\n\tmargin-left: 38px;\r\n}\r\n.ml-39 {\r\n\tmargin-left: 39px;\r\n}\r\n.ml-40 {\r\n\tmargin-left: 40px;\r\n}\r\n.ml-45 {\r\n\tmargin-left: 45px;\r\n}\r\n.ml-50 {\r\n\tmargin-left: 50px;\r\n}\r\n.ml-55 {\r\n\tmargin-left: 55px;\r\n}\r\n.ml-60 {\r\n\tmargin-left: 60px;\r\n}\r\n.ml-65 {\r\n\tmargin-left: 65px;\r\n}\r\n.ml-70 {\r\n\tmargin-left: 70px;\r\n}\r\n.ml-75 {\r\n\tmargin-left: 75px;\r\n}\r\n.ml-80 {\r\n\tmargin-left: 80px;\r\n}\r\n.ml-85 {\r\n\tmargin-left: 85px;\r\n}\r\n.ml-90 {\r\n\tmargin-left: 90px;\r\n}\r\n.ml-95 {\r\n\tmargin-left: 95px;\r\n}\r\n.ml-100 {\r\n\tmargin-left: 100px;\r\n}\r\n.ml-105 {\r\n\tmargin-left: 105px;\r\n}\r\n.ml-110 {\r\n\tmargin-left: 110px;\r\n}\r\n.ml-115 {\r\n\tmargin-left: 115px;\r\n}\r\n.ml-120 {\r\n\tmargin-left: 120px;\r\n}\r\n.ml-125 {\r\n\tmargin-left: 125px;\r\n}\r\n.ml-130 {\r\n\tmargin-left: 130px;\r\n}\r\n.ml-135 {\r\n\tmargin-left: 135px;\r\n}\r\n.ml-140 {\r\n\tmargin-left: 140px;\r\n}\r\n.ml-145 {\r\n\tmargin-left: 145px;\r\n}\r\n.ml-150 {\r\n\tmargin-left: 150px;\r\n}\r\n/* margin right */\r\n.mr-6 {\r\n\tmargin-right: 6px;\r\n}\r\n.mr-7 {\r\n\tmargin-right: 7px;\r\n}\r\n.mr-8 {\r\n\tmargin-right: 8px;\r\n}\r\n.mr-9 {\r\n\tmargin-right: 9px;\r\n}\r\n.mr-10 {\r\n\tmargin-right: 10px;\r\n}\r\n.mr-11 {\r\n\tmargin-right: 11px;\r\n}\r\n.mr-12 {\r\n\tmargin-right: 12px;\r\n}\r\n.mr-13 {\r\n\tmargin-right: 13px;\r\n}\r\n.mr-14 {\r\n\tmargin-right: 14px;\r\n}\r\n.mr-15 {\r\n\tmargin-right: 15px;\r\n}\r\n.mr-16 {\r\n\tmargin-right: 16px;\r\n}\r\n.mr-17 {\r\n\tmargin-right: 17px;\r\n}\r\n.mr-18 {\r\n\tmargin-right: 18px;\r\n}\r\n.mr-19 {\r\n\tmargin-right: 19px;\r\n}\r\n.mr-20 {\r\n\tmargin-right: 20px;\r\n}\r\n.mr-21 {\r\n\tmargin-right: 21px;\r\n}\r\n.mr-22 {\r\n\tmargin-right: 22px;\r\n}\r\n.mr-23 {\r\n\tmargin-right: 23px;\r\n}\r\n.mr-24 {\r\n\tmargin-right: 24px;\r\n}\r\n.mr-25 {\r\n\tmargin-right: 25px;\r\n}\r\n.mr-26 {\r\n\tmargin-right: 26px;\r\n}\r\n.mr-27 {\r\n\tmargin-right: 27px;\r\n}\r\n.mr-28 {\r\n\tmargin-right: 28px;\r\n}\r\n.mr-29 {\r\n\tmargin-right: 29px;\r\n}\r\n.mr-30 {\r\n\tmargin-right: 30px;\r\n}\r\n.mr-31 {\r\n\tmargin-right: 31px;\r\n}\r\n.mr-32 {\r\n\tmargin-right: 32px;\r\n}\r\n.mr-33 {\r\n\tmargin-right: 33px;\r\n}\r\n.mr-34 {\r\n\tmargin-right: 34px;\r\n}\r\n.mr-35 {\r\n\tmargin-right: 35px;\r\n}\r\n.mr-36 {\r\n\tmargin-right: 36px;\r\n}\r\n.mr-37 {\r\n\tmargin-right: 37px;\r\n}\r\n.mr-38 {\r\n\tmargin-right: 38px;\r\n}\r\n.mr-39 {\r\n\tmargin-right: 39px;\r\n}\r\n.mr-40 {\r\n\tmargin-right: 40px;\r\n}\r\n.mr-45 {\r\n\tmargin-right: 45px;\r\n}\r\n.mr-50 {\r\n\tmargin-right: 50px;\r\n}\r\n.mr-55 {\r\n\tmargin-right: 55px;\r\n}\r\n.mr-60 {\r\n\tmargin-right: 60px;\r\n}\r\n.mr-65 {\r\n\tmargin-right: 65px;\r\n}\r\n.mr-70 {\r\n\tmargin-right: 70px;\r\n}\r\n.mr-75 {\r\n\tmargin-right: 75px;\r\n}\r\n.mr-80 {\r\n\tmargin-right: 80px;\r\n}\r\n.mr-85 {\r\n\tmargin-right: 85px;\r\n}\r\n.mr-90 {\r\n\tmargin-right: 90px;\r\n}\r\n.mr-95 {\r\n\tmargin-right: 95px;\r\n}\r\n.mr-100 {\r\n\tmargin-right: 100px;\r\n}\r\n.mr-105 {\r\n\tmargin-right: 105px;\r\n}\r\n.mr-110 {\r\n\tmargin-right: 110px;\r\n}\r\n.mr-115 {\r\n\tmargin-right: 115px;\r\n}\r\n.mr-120 {\r\n\tmargin-right: 120px;\r\n}\r\n.mr-125 {\r\n\tmargin-right: 125px;\r\n}\r\n.mr-130 {\r\n\tmargin-right: 130px;\r\n}\r\n.mr-135 {\r\n\tmargin-right: 135px;\r\n}\r\n.mr-140 {\r\n\tmargin-right: 140px;\r\n}\r\n.mr-145 {\r\n\tmargin-right: 145px;\r\n}\r\n.mr-150 {\r\n\tmargin-right: 150px;\r\n}\r\n/*--------------------------\r\n\t06. border\r\n--------------------------*/\r\n/* border width */\r\n.border-width-2 {\r\n\tborder-width: 2px;\r\n}\r\n.border-width-3 {\r\n\tborder-width: 3px;\r\n}\r\n.border-width-4 {\r\n\tborder-width: 4px;\r\n}\r\n.border-width-5 {\r\n\tborder-width: 5px;\r\n}\r\n.border-width-6 {\r\n\tborder-width: 6px;\r\n}\r\n.border-width-7 {\r\n\tborder-width: 7px;\r\n}\r\n.border-width-8 {\r\n\tborder-width: 8px;\r\n}\r\n.border-width-9 {\r\n\tborder-width: 9px;\r\n}\r\n.border-width-10 {\r\n\tborder-width: 10px;\r\n}\r\n/* border left width */\r\n.border-left-width-2 {\r\n\tborder-left-width: 2px !important;\r\n}\r\n.border-left-width-3 {\r\n\tborder-left-width: 3px !important;\r\n}\r\n.border-left-width-4 {\r\n\tborder-left-width: 4px !important;\r\n}\r\n.border-left-width-5 {\r\n\tborder-left-width: 5px !important;\r\n}\r\n.border-left-width-6 {\r\n\tborder-left-width: 6px !important;\r\n}\r\n.border-left-width-7 {\r\n\tborder-left-width: 7px !important;\r\n}\r\n.border-left-width-8 {\r\n\tborder-left-width: 8px !important;\r\n}\r\n.border-left-width-9 {\r\n\tborder-left-width: 9px !important;\r\n}\r\n.border-left-width-10 {\r\n\tborder-left-width: 10px !important;\r\n}\r\n/* border right width */\r\n.border-right-width-2 {\r\n\tborder-right-width: 2px;\r\n}\r\n.border-right-width-3 {\r\n\tborder-right-width: 3px;\r\n}\r\n.border-right-width-4 {\r\n\tborder-right-width: 4px;\r\n}\r\n.border-right-width-5 {\r\n\tborder-right-width: 5px;\r\n}\r\n.border-right-width-6 {\r\n\tborder-right-width: 6px;\r\n}\r\n.border-right-width-7 {\r\n\tborder-right-width: 7px;\r\n}\r\n.border-right-width-8 {\r\n\tborder-right-width: 8px;\r\n}\r\n.border-right-width-9 {\r\n\tborder-right-width: 9px;\r\n}\r\n.border-right-width-10 {\r\n\tborder-right-width: 10px;\r\n}\r\n/* border top width */\r\n.border-top-width-2 {\r\n\tborder-top-width: 2px;\r\n}\r\n.border-top-width-3 {\r\n\tborder-top-width: 3px;\r\n}\r\n.border-top-width-4 {\r\n\tborder-top-width: 4px;\r\n}\r\n.border-top-width-5 {\r\n\tborder-top-width: 5px;\r\n}\r\n.border-top-width-6 {\r\n\tborder-top-width: 6px;\r\n}\r\n.border-top-width-7 {\r\n\tborder-top-width: 7px;\r\n}\r\n.border-top-width-8 {\r\n\tborder-top-width: 8px;\r\n}\r\n.border-top-width-9 {\r\n\tborder-top-width: 9px;\r\n}\r\n.border-top-width-10 {\r\n\tborder-top-width: 10px;\r\n}\r\n/* border bottom width */\r\n.border-bottom-width-2 {\r\n\tborder-bottom-width: 2px;\r\n}\r\n.border-bottom-width-3 {\r\n\tborder-bottom-width: 3px;\r\n}\r\n.border-bottom-width-4 {\r\n\tborder-bottom-width: 4px;\r\n}\r\n.border-bottom-width-5 {\r\n\tborder-bottom-width: 5px;\r\n}\r\n.border-bottom-width-6 {\r\n\tborder-bottom-width: 6px;\r\n}\r\n.border-bottom-width-7 {\r\n\tborder-bottom-width: 7px;\r\n}\r\n.border-bottom-width-8 {\r\n\tborder-bottom-width: 8px;\r\n}\r\n.border-bottom-width-9 {\r\n\tborder-bottom-width: 9px;\r\n}\r\n.border-bottom-width-10 {\r\n\tborder-bottom-width: 10px;\r\n}\r\n/* border style */\r\n.border-style-solid {\r\n\tborder-style: solid;\r\n}\r\n.border-style-dashed {\r\n\tborder-style: dashed;\r\n}\r\n.border-style-dotted {\r\n\tborder-style: dotted;\r\n}\r\n.border-style-double {\r\n\tborder-style: double;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
